"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MetricsDisplayGrid = exports.getRowDataForMetric = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var react_1 = __importDefault(require("react"));
var Localize_1 = require("../../../gen-src/Localize");
var queries_1 = require("../../../gen-src/queries");
var LinkCellFormatter_1 = require("../datagrid/cellFormatters/LinkCellFormatter");
var ObfuscatedCellFormatter_1 = require("../datagrid/cellFormatters/ObfuscatedCellFormatter");
var projectContainerType = 'Project';
function getRowDataForMetric(metric) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
    return {
        id: metric.id,
        name: metric.name,
        vizportalUrlId: metric.vizportalUrlId,
        viewName: (_b = (_a = metric.underlyingView) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : null,
        viewPath: (_d = (_c = metric.underlyingView) === null || _c === void 0 ? void 0 : _c.path) !== null && _d !== void 0 ? _d : null,
        workbookName: (_g = (_f = (_e = metric.underlyingView) === null || _e === void 0 ? void 0 : _e.workbook) === null || _f === void 0 ? void 0 : _f.name) !== null && _g !== void 0 ? _g : null,
        workbookVizportalUrlId: (_k = (_j = (_h = metric.underlyingView) === null || _h === void 0 ? void 0 : _h.workbook) === null || _j === void 0 ? void 0 : _j.vizportalUrlId) !== null && _k !== void 0 ? _k : null,
        containerName: metric.containerName,
        containerType: metric.containerType,
        projectVizportalUrlId: metric.projectVizportalUrlId,
        ownerName: (_m = (_l = metric.owner) === null || _l === void 0 ? void 0 : _l.name) !== null && _m !== void 0 ? _m : null,
        ownerUsername: (_p = (_o = metric.owner) === null || _o === void 0 ? void 0 : _o.username) !== null && _p !== void 0 ? _p : null,
        ownerDomain: (_r = (_q = metric.owner) === null || _q === void 0 ? void 0 : _q.domain) !== null && _r !== void 0 ? _r : null,
    };
}
exports.getRowDataForMetric = getRowDataForMetric;
function columns() {
    var cols = [
        function (sortParams) { return ({
            name: 'name',
            dataKey: queries_1.MetricOrderField.NAME,
            headerText: Localize_1.Messages.GridHeaderName(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter)(function (_a) {
                var name = _a.name;
                return name === null;
            }, function (_a) {
                var name = _a.name;
                return name;
            }, function (urls, _a) {
                var vizportalUrlId = _a.vizportalUrlId;
                return vizportalUrlId ? urls.metricPath(vizportalUrlId) : null;
            }),
            resizable: true,
            sortable: true,
        }); },
        function (sortParams) { return ({
            name: 'view',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderView(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter)(function (_a) {
                var viewName = _a.viewName;
                return viewName === null;
            }, function (_a) {
                var viewName = _a.viewName;
                return viewName;
            }, function (urls, _a) {
                var viewPath = _a.viewPath;
                return viewPath ? urls.viewPath(viewPath) : null;
            }),
            resizable: true,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'workbook',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderWorkbook(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, ObfuscatedCellFormatter_1.createObfuscatedLinkOrTextCellFormatter)(function (_a) {
                var workbookName = _a.workbookName;
                return workbookName === null;
            }, function (_a) {
                var workbookName = _a.workbookName;
                return workbookName;
            }, function (urls, _a) {
                var workbookVizportalUrlId = _a.workbookVizportalUrlId;
                return workbookVizportalUrlId ? urls.workbookLineagePath(workbookVizportalUrlId) : null;
            }),
            resizable: true,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'location',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.GridHeaderLocation(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, LinkCellFormatter_1.createLinkOrTextCellFormatter)(function (_a) {
                var containerType = _a.containerType, containerName = _a.containerName;
                return containerType === projectContainerType ? containerName : Localize_1.Messages.PersonalSpaceName();
            }, function (urls, _a) {
                var projectVizportalUrlId = _a.projectVizportalUrlId, containerType = _a.containerType;
                return (projectVizportalUrlId && containerType === projectContainerType ? urls.projectPath(projectVizportalUrlId) : null);
            }),
            resizable: true,
            sortable: false,
        }); },
        function (sortParams) { return ({
            name: 'owner',
            dataKey: data_catalog_shared_1.UnsortableColumnKey,
            headerText: Localize_1.Messages.Owner(),
            headerFormatter: (0, data_catalog_shared_1.createSortableHeaderFormatter)(sortParams),
            cellFormatter: (0, LinkCellFormatter_1.createLinkCellFormatter)(
            // If ownerName, ownerUsername, and ownerDomain are null, there is likely a permission denied issue
            function (_a) {
                var ownerName = _a.ownerName, ownerUsername = _a.ownerUsername;
                return ownerName || ownerUsername || '';
            }, function (urls, _a) {
                var ownerUsername = _a.ownerUsername, ownerDomain = _a.ownerDomain;
                if (ownerUsername && ownerDomain) {
                    return urls.userPath(ownerUsername, ownerDomain);
                }
                else {
                    return '';
                }
            }),
            resizable: true,
            sortable: false,
        }); }
    ];
    return cols.filter(Boolean);
}
function MetricsDisplayGrid(props) {
    var cols = columns().map(function (columnFactory) { return columnFactory(props); });
    return (react_1.default.createElement(data_catalog_shared_1.ExplorerStyledDisplayGrid, { columns: cols, rowStore: props.rowStore, emptyGridMessage: props.emptyGridMessage, rowCount: props.rowCount, renderErrors: data_catalog_shared_1.reportGraphQLErrors, orderBy: props.orderBy, updateSortOrder: props.updateSortOrder }));
}
exports.MetricsDisplayGrid = MetricsDisplayGrid;
//# sourceMappingURL=MetricsDisplayGrid.js.map